import type { Feature } from '@/lib/tiers';

/**
 * Open the plans pop-up (components/UpgradeDialog.tsx), from anywhere: a lock,
 * a locked choice in a list. An event, like the Quick Learn tour, so a lock
 * deep in a page needs no provider around it.
 */
export const UPGRADE_EVENT = 'copyfi:upgrade';

export function openUpgrade(feature?: Feature) {
  window.dispatchEvent(new CustomEvent(UPGRADE_EVENT, { detail: { feature } }));
}
